import {
    OPEN_RIBBON_DROPDOWN_MENU,
    CLOSE_RIBBON_DROPDOWN_MENU,
    TOGGLE_RIBBON_DROPDOWN_MENU,
    ACTIVE_RIBBON_DROPDOWN_ITEM,
} from './constants'

export function openDropdownMenu(moduleName, dropDownName) {
    return {
        type: OPEN_RIBBON_DROPDOWN_MENU,
        data: {
            moduleName,
            dropDownName,
        },
    }
}

export function closeDropdownMenu(moduleName, dropDownName) {
    return {
        type: CLOSE_RIBBON_DROPDOWN_MENU,
        data: {
            moduleName,
            dropDownName,
        },
    }
}

export function toggleDropdownMenu(moduleName, dropDownName) {
    return {
        type: TOGGLE_RIBBON_DROPDOWN_MENU,
        data: {
            moduleName,
            dropDownName,
        },
    }
}

export function activeItem(moduleName, dropDownName, name) {
    return {
        type: ACTIVE_RIBBON_DROPDOWN_ITEM,
        data: {
            moduleName,
            dropDownName,
            name,
        },
    }
}
